import store from "../store/index"
import { axiosApi, uploadApi } from "./api"
import { dayEnd, dayStart, yearStart, yearEnd, monthStart, monthEnd } from '../util/DateUtil'
import Axios from "axios"

/**
 * API 列表
 * @type {function(*=): *}
 */
// 获取项目的所有摄像头
export const _getProjectCamera=(data)=>{
	return axiosApi("get",'/device/camera/project')(data)
}

// 获取摄像头的视频流地址 
export const _getCameraPlayAddress=(data)=>{
	return axiosApi("get",'/ezviz/playAddress')(data)
}

//逆变器
export function InverterArea(areaId) {
    return axiosApi("get", "/loop/inverter/area", true)({
        areaId
    })
}

// 逆变器总发电 和日发电
export function getPowerloopMax(data) {
	return axiosApi("get",'/power/loop/last/val')(data)
}

// 登录
export function login(data) {
	return axiosApi("post",'/guest/tel/login',false)(data)
}




